import React from "react";
import { Router, navigate, useLocation } from "@reach/router";

import { Viewer } from "components/auth/types";
import ContainerWithSidebar from "components/common/layout/ContainerWithSidebar";

import OrgSettings from "../settings/pages/organization";
import ScheduledUpdates from "../settings/pages/scheduled-updates";
import TeamSettings from "../settings/pages/team";
import TeamSettingsNew from "../settings/pages/team/create";
import TeamSettingsUpdate from "../settings/pages/team/update";
import TemplatesNew from "../template-groups/new";
import TemplatesUpdate from "../template-groups/update";
import TemplateSettings from "../settings/pages/templates";
import PropertySettingsPage from "../settings/property";
import Imports from "./pages/imports";
import PropertyNewPage from "./property/new";
import Sidebar from "./sidebar";
import { sortAndFilterLists } from "./list-utils";

interface Props {
  path: string;
  viewer: Viewer
}

const getFirstListId = (viewer:Viewer):string =>
  sortAndFilterLists(viewer, viewer.lists ?? [])[0].id;

const SettingsPage: React.FC<Props> = ({ viewer }) => {
  const location = useLocation();
  if (location.pathname.match("/dash/manager/settings[/]?$")) {
    if (viewer?.isSupervisor) {
      navigate("/dash/manager/settings/organization");
    } else {
      navigate(`/dash/manager/settings/property/${getFirstListId(viewer)}/lists`);
    }
  }

  return <ContainerWithSidebar>
    <Sidebar viewer={viewer} />
    <Router primary={false} style={{ width: "100%" }}>
      <OrgSettings path="organization" viewer={viewer} />
      <PropertyNewPage path="property/new" viewer={viewer}/>
      <PropertySettingsPage path="property/:listId/*" viewer={viewer}/>
      <TeamSettings path="team" viewer={viewer} />
      <TeamSettingsNew path="team/new" viewer={viewer} />
      <TeamSettingsUpdate path="team/:userId" />
      <ScheduledUpdates path="scheduled-updates" viewer={viewer} />
      <Imports path="imports/*" viewer={viewer} />
      <TemplateSettings path="templates" viewer={viewer} />
      <TemplatesNew path="templates/new" viewer={viewer} />
      <TemplatesUpdate path="templates/update/:id" viewer={viewer} />
    </Router>
  </ContainerWithSidebar>;
};

export default SettingsPage;
